<div mat-dialog-content>
    <div class="mt-2" fxLayout="column" fxLayoutAlign="space-between center" fxLayoutGap="10px">
        <button mat-raised-button color="primary" class="w-100 ok-button mt-2" color="primary" (click)="onSendToCustomer()" [disabled]="!customerHasEmail">{{'MENU.SEND-FORM-QUESTIONNAIRE-TO-PATIENT' | translate}}</button>
        <button mat-raised-button color="primary" class="w-100 ok-button mt-2" color="primary" (click)="onFillByTherapist()" cdkFocusInitial>{{'MENU.Fill-FORM-QUESTIONNAIRE' | translate}}</button>
        <button mat-raised-button (click)="onCancel()" class="w-100 mt-2" cdkFocusInitial>{{'MENU.CANCEL' | translate}}</button>
    </div>
</div>
  
  
  
